import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AlertController, Platform} from '@ionic/angular';
import {LocalDataSource} from '../../../ng2-smart-table/lib/data-source/local/local.data-source';
import {ContactNumberData} from '../../../interfaces/contact-number-data';
import {AddressData} from '../../../interfaces/address-data';
import {Events} from '../../../providers/events';
import {ModalService} from '../../../providers/modal.service';
import {ModalPhonePanelPage} from '../../modals/modal-phone-panel/modal-phone-panel';
import { firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-phone-data',
  templateUrl: 'phone-data.html',
  styleUrls: ['./phone-data.scss']
})
export class PhoneDataComponent implements OnInit {
  data: LocalDataSource = new LocalDataSource();
  actions: any = null;
  @Input()
  addressData: AddressData;
  @Output() selectedRow = new EventEmitter();
  @Output() outContractData = new EventEmitter();

  

  isCore = true;
  settings: {add?:any,delete?:any, edit?:any, columns: any; actions: any; filter: any; pager: { display: boolean; perPage: number; }; hideSubHeader: boolean; noDataMessage: string; };

  constructor(private alertController: AlertController, private events: Events, 
    private plf: Platform, private modalCtrl: ModalService, private translate:TranslateService) {

    this.isCore = this.plf.is('desktop'); // TODOALEX
  }

  @Input() set phoneData(data: Array<ContactNumberData>) {
    if(data instanceof Array) {
      this.data.load(data);
      this.data.setSort([{field: 'type', direction: 'asc'}]);
    }
  }

  private expantSettings() {
    this.settings.actions = {
      edit: true,
      delete: true,
      add: true
    };
    this.settings.hideSubHeader = false;
    this.settings.add = {
      addButtonContentIcon: 'add-circle',
      createButtonContentIcon: 'checkmark-circle-outline',
      cancelButtonContentIcon: 'close',
      confirmCreate: true
    };
    this.settings.delete = {
      deleteButtonContentIcon: 'trash',
      confirmDelete: true
    };
    this.settings.edit = {
      editButtonContentIcon: 'create',
      saveButtonContentIcon: 'checkmark-circle-outline',
      cancelButtonContentIcon: 'close',
      confirmSave: true
    };
  }

  @Input() set isEdit(value) {

    if (value === true) {
      this.ngOnInit().then(() => {
        this.expantSettings();
      })
    } else {
      this.ngOnInit().then(() => {
        this.settings.actions = {
          edit: false,
          delete: false,
          add: false
        };
        this.settings.hideSubHeader = true;
      });
    }
  }

  async ngOnInit(){
    if(!this.settings) {
    let translateData = await firstValueFrom(this.translate.get(['Type', 'LandlinePhone', 'MobilePhone', 'Fax', 'Residence', 'Number','Comment', 'Message.NoPhoneContact']));
    translateData = Object.values(translateData);

    this.settings = {
      columns: {
        type: {
          title: translateData[0],
          editor: {
            type: 'list',
            config: {
              list: [
                {value: translateData[1], title: translateData[1]},
                {value: translateData[2], title: translateData[2]},
                {value: translateData[3], title: translateData[3]},
                {value: translateData[4], title: translateData[4]}
              ]
            }
          }
        },
        phoneNumber: {
          title: translateData[5]
        },
        info: {
          title: translateData[6]
        }
      },
      actions: null,
      filter: null,
      pager: {
        display: true,
        perPage: 5
      },
      hideSubHeader: true,
      noDataMessage: translateData[7]
    };
  }
  }

  rowSelect(rowData) {
      if(this.settings.actions && this.settings.actions.edit) {
        return;
      }

      this.selectedRow.emit({phoneData: rowData, addressData: this.addressData});
      this.modalCtrl.openModal(ModalPhonePanelPage);
  }

  onEdit(event) {
    event.confirm.resolve();
    this.data.getAll()
      .then((data) => {
        this.outContractData.emit(data);
      });

  }

  onCreate(event) {
    // let newContact = new ContactNumberData();
    // event.newData = Object.assign(newContact, event.newData);
    // this.data.refresh();
    // this.rowSelect(event.newData);
    // event.confirm.resolve();
    // this.data.getAll()
    // .then((data) => {

    //   data = data.map((rowData) => {
    //     let contact = new ContactNumberData();
    //     return Object.assign(contact, rowData);
    //   });

    //   this.outContractData.emit(data);
    // });


    const newContact = new ContactNumberData();
    event.newData = Object.assign(newContact, event.newData);

    this.rowSelect(event.newData);

    event.confirm.promise.then(() => {
      this.data.getAll()
        .then((data) => {
          data = data.map((rowData) => {
            const contact = new ContactNumberData();
            return Object.assign(contact, rowData);
          });
          this.outContractData.emit(data);
        });

    });
    event.confirm.resolve();
  }


  async deleteConfirm(event) {
    const alert = await this.alertController.create({
      header: this.translate.instant('Warning'),
      message: this.translate.instant('Message.DeletePhoneData'),
      buttons: [
        {
          text: this.translate.instant('Cancel'),
          role: 'cancel',
          handler: () => {
            event.confirm.reject();
          }
        },
        {
          text: this.translate.instant('Delete'),
          handler: () => {

            event.confirm.promise.then(() => {
              this.data.getAll()
                .then((data) => {
                  this.outContractData.emit(data);
                  this.events.publish('delPhoneData', {phoneData: data, addressData: this.addressData});
                });
            });

            this.data.refresh();
            event.confirm.resolve();
          }
        },
      ]
    });
    alert.present();
  }

}
